import FieldMixins from './mixins/field_mixin.js';

export default Vue.extend({
  mixins: [FieldMixins],

  props: {
    pageIndex: Number,
    pageLength: Number,
  },

  data() {
    return {
      descriptionExist: false,
      isNewField: this.field.isNew(),
    };
  },

  template: `
    <div class="field-view page-field"
         :class="{ 'field-editing': editing }"
         @click='enableEdit'>
      <div class="field-drag-area dragable">
        <i class="slp-move text-large"></i>
      </div>
      <div class="page-tip-container">
        <div class="page-detail">
          第{{ pageIndex }}页,共{{ pageLength }}页
        </div>
      </div>
      <div class="field-header">
        <div class="justify-box title-container">
          <div class="content">
            <input type="text" :placeholder='defaultFieldTitle' v-model.trim='field.title' v-if='editing' ref='titleInput' />
            <template v-else>
              <div v-if="field.title">{{ field.title }}</div>
              <div class="placeholder" v-else>{{ defaultFieldTitle }}</div>
            </template>
          </div>
          <div class="description-add-btn clickable vertical-middle" v-if='editing' @click.stop='toggleDescription'>
            <i class="slp-check" v-if='descriptionExist'></i>
            <i class="slp-empty" v-else></i>
            <span>&nbsp;添加描述</span>
          </div>
        </div>
        <div class="description-container" v-if='descriptionExist'>
          <input type="text"
                :disabled='!editing'
                ref='descriptionInput'
                v-model.trim='field.description'
                placeholder='请输入描述' />
        </div>
      </div>
      <div class="field-footer justify-between" v-if='editing'>
        <div class="left"></div>
        <div class="field-actions vertical-middle">
          <div class="field-normal-actions">
            <span class='normal-action' @click='copyField'>
              <i class="slp-copy"></i>
            </span>
            <span class='normal-action' @click.stop='removeField'>
              <i class="slp-trash"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  `,

  created() {
  },

  computed: {
    defaultFieldTitle() {
      return `第${this.pageIndex}页`;
    },
  },

  methods: {
    enableEdit() {
      if (this.$el.getAttribute('moved')) return undefined;
      if (this.editing) return true;
      this.editing = true;
      return undefined;
    },

    toggleDescription() {
      if (this.descriptionExist) this.field.description = '';
      this.descriptionExist = !this.descriptionExist;
      if (!this.descriptionExist) return;
      this.$nextTick(() => {
        if (this.$refs.descriptionInput) this.$refs.descriptionInput.focus();
      });
    },

    focusTitleIfNeed() {
      this.$refs.titleInput.focus();
    },
  },
});
